// extracted by mini-css-extract-plugin
export default {"wrapper":"UVXwK5ffFUALXrjdpvaW","cols":"hOXGkgiM46Yh1XbFYeIC","cardContainer":"jUOSLbdDehilPJXwAq6v"};